import React from 'react';
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Createtabs from 'components/Createtabs';
import cn from 'classnames';
import ModifyCollege from './components/ModifyCollege';
import DeleteCoachByCollege from './components/DeleteCoach';
import AddCollege from './components/AddCollege';
import styles from './style.scss';

const tabs = ['Add College', 'Modify College', 'Delete Coach By College'];

const CollegeView = (props) => {
  const { tab } = props;
  const renderAddCollege = renderIf(tab === 0);
  const renderModifyCollege = renderIf(tab === 1);
  const renderDeleteCoach = renderIf(tab === 2);
  return (
    <div className={cn('col s12')}>
      <Createtabs
        tabs={tabs}
        index={props.tab}
        activeClass={styles.activeClass}
        container={styles.container}
        tabListener={props.tabListener}
      />
      <div className={cn('col s12', styles.tabViews)}>
        {renderAddCollege(
          <AddCollege {...props} />,
        )}
        {renderModifyCollege(
          <ModifyCollege {...props} />,
        )}
        {renderDeleteCoach(
          <DeleteCoachByCollege {...props} />,
        )}
      </div>
    </div>
  );
};

CollegeView.propTypes = {
  tabListener: PropTypes.func.isRequired,
  tab: PropTypes.number.isRequired,
};

export default CollegeView;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/CollegeView/View.js